import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

const DocumentPageContainer = styled.div`
  min-height: 75vh;
  max-width: 1100px;
  margin: 0 auto;
  padding: 6rem clamp(16px, 5vw, 48px) 3rem;

  h1 { font-size: clamp(1.8rem, 5vw, 3rem); }
  h2 { font-size: clamp(1.3rem, 3vw, 1.8rem); }

  h1,
  h2 {
    margin: 36px 0;
  }

  p {
    font-size: 1.25rem;
    font-weight: 500;
    margin: 18px 0;
  }
`;

const BlurBackground = styled.div`
  min-height: 30vh;
  border-radius: 10px;
  background: var(--card);
  border: 1px solid var(--bd);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(13px);
  width: 100%;
  padding: clamp(16px, 4vw, 40px);
  font-size: 1.25rem;
  font-weight: 500;

  * {
    margin: 1rem;
  }

  a {
    color: white;
  }
`;

const LinkToHome = styled(NavLink)`
  background: rgba(4, 12, 15, 0.95);
  border: 1px solid var(--bd);
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1;
  min-height: 44px;
  padding: 0 18px;
  gap: 8px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--c);
  text-decoration: none;
  font-weight: 600;
  transition: border-color 200ms ease, background 200ms ease;

  &:hover {
    border-color: var(--c);
    background: #10232a;
  }
`;

interface DocumentPageProps {
  children: React.ReactNode;
}

const HomeIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 12L5 10M5 10L12 3L19 10M5 10V20C5 20.5523 5.44772 21 6 21H9M19 10L21 12M19 10V20C19 20.5523 18.5523 21 18 21H15M9 21C9.55228 21 10 20.5523 10 20V16C10 15.4477 10.4477 15 11 15H13C13.5523 15 14 15.4477 14 16V20C14 20.5523 14.4477 21 15 21M9 21H15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
};

const DocumentPage = ({ children }: DocumentPageProps): JSX.Element => {
  return (
    <DocumentPageContainer>
      <LinkToHome to='/'>
        <HomeIcon />
        Home
      </LinkToHome>
      <BlurBackground>{children}</BlurBackground>
    </DocumentPageContainer>
  );
};

export default DocumentPage;
